import Image from "next/image";
import { useRouter } from "next/router";
import React from "react";
import Utils from "../../utils/Utils";

export const TrendFinder = ({ show = true }) => {
  const router = useRouter();
  return (
    <div className="container stats-explained">
      <div className="text-left">
        <h2>Trend Finder</h2>
        <h5>How exactly does the Trend Finder tool work?</h5>
      </div>
      <div className="text-left" style={{ display: "flex", flexDirection: "column" }}>
        <p>
          <b style={{ color: "#d07c3b" }}>Trend Finder</b> compares historical betting results to ShotQuality expected
          scores, providing a side-by-side look at how teams performed against the odds versus how ShotQuality expected
          them to. Use sliders and game-type checkboxes to refine results, discover upcoming occurrences and pinpoint
          past games.
        </p>

        <Image
          src={Utils.getAsset("TrendFinderExampleImage.png")}
          alt="picture showing how the trend finder tool works"
          className="rounded"
        />

        <a
          href={`/trend-finder`}
          target={"_blank"}
          style={{
            padding: "15px 50px",
            width: "200px",
            alignSelf: "center",
            marginTop: "15px",
          }}
          className="btn btn-orange"
        >
          Go to the Tool
        </a>
      </div>
    </div>
  );
};
